import React, { FC, useState } from 'react';
import { FinePrintMessage }    from '../../../components/util/messaging/FinePrintMessage';

interface Props {
	isRecurrence?: boolean,
	withContainer?: boolean,
}

const defaultProps: Props = {
	isRecurrence:  true,
	withContainer: true,
}

const ActivityRecurrenceLabel: FC<Props> = ( props ) => {
	
	let Container = props.withContainer ? FinePrintMessage : React.Fragment
	
	return props.isRecurrence
	       ? <Container>Activity Recurrence</Container>
	       : <Container>Recurring Activity</Container>;
};

ActivityRecurrenceLabel.defaultProps = defaultProps;

export { ActivityRecurrenceLabel }

